import "./ueber.css";

import img1 from "../assets/img/Solveig-2018.jpg";
import img2 from "../assets/img/Fruhling-Ammersee-Yoga.JPG";

function Ueber() {
  return <div className="main-wrapper">
    
      
    
      <h2>Über Mich</h2>

      <h3>Hallo & Herzlich willkommen!</h3>

      <img className="img1" src={img1}></img>

      <p>
        Als Heilpraktikerin für Psychotherapie und zertifizierte Holistische Tanz- und Bewegungstherapeutin (HTB) arbeite ich sowohl in meiner Praxis für Psychotherapie als auch in meinen Gruppenangeboten für Kreativen Tanz ganzheitlich, clientenzentriert und integrativ. Mein Ansatz ist Ressourcen-orientiert. Der Mensch steht bei mir immer im Mittelpunkt.
      </p>
      
      <p>
        Nach meinen Ausbildungen für Tanzpädagogik und Tanztherapie habe ich verschiedene Fortbildungen in körperorientierten Methoden, freiem Tanz und in Gesprächstherapie nach Carl Rogers gemacht. Außerdem habe ich in einer psychosomatischen Klinik gearbeitet und Erfahrung in Gruppen- und Einzelbegleitung.
      </p>

      <p>
        Ich bin Mutter zweier nun erwachsener Kinder, lebe seit über 20 Jahren in München und liebe auch privat das Tanzen, die Gemeinschaft und in der Natur zu sein.
      </p>

      <p>
        Vor vielen Jahren habe ich in einer sehr herausfordernden Lebensphase selbst erfahren, wie unterstützend Tanz und Bewegung sein können, wie gut ich damit raus aus dem Kopf und rein in den Körper komme, und gelernt, was mir hilft, wieder „Boden unter den Füßen zu spüren“.
      </p>

      <p>
        Diese Erfahrung gebe ich gerne weiter, ich begleite Menschen in Veränderungs- und Wachstumsprozessen mit viel Einfühlungsvermögen, Empathie und Freude.
      </p>

      <p>
        <h3>Ausbildungen</h3>
        <div className="bulletpoint"/>Kreativer Tanz & Heilsame Bewegung (Tanzpädagogik) bei Barbara Hundshammer, zibko<br/>
        <div className="bulletpoint"/>Holistische Tanz- und Bewegungstherapie (Tanztherapie) bei Barbara Hundshammer, zibko<br/>
      </p>

      <p>
        <h3>Fortbildungen</h3>
        <div className="bulletpoint"/>Prä- und Perinatale Prägungen (zibko)<br/>
        <div className="bulletpoint"/>Trauma und Tanztherapie (zibko)<br/>
        <div className="bulletpoint"/>Sexuelle Wunden (zibko)<br/>
        <div className="bulletpoint"/>Body-Mind-Centering (Nina Wehnert und Stefanie Hahnzog)<br/>
        <div className="bulletpoint"/>Continuum (Somatische Akademie Berlin, Robin Becker und Susan Harper)<br/>
        <div className="bulletpoint"/>Basiskurs Gesprächstherapie nach Carl Rogers (Stefan Ritsche)<br/>
        <div className="bulletpoint"/>Kreativer Tanz und Nervensystem (zibko)<br/>
      </p>

      <p>
        <h3>Tanz und Bewegung</h3>
        <div className="bulletpoint"/>Yoga – praktiziere ich regelmäßig seit 2008 und ich binde hin und wieder gerne eine Sequenz zum Ankommen in meine Einzel- oder Gruppenstunden ein.<br/>
        <div className="bulletpoint"/>Contact Improvisation & ContacTango – bringt mich am schnellsten vom Kopf in den Körper (Peter Krempelsetzer, Sebastian Mayer, Leilani Weis, Mirva Mäkinen, Ralf Jaroschinski und Nita Little)<br/>
        <div className="bulletpoint"/>Feldenkrais – übt die Körperwahrnehmung (Sebastian Mayer) <br/>
        <div className="bulletpoint"/>Tango Argentino – macht glücklich (Patrizia und Michael Kronthaler)<br/>
      </p>

      <img className="img" src={img2}></img>

    </div>
}
export default Ueber;